/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import { getFeatureFlags } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import DeliveryExtraFee from '../../../../Checkout/containers/CheckoutFloral/Partials/OrderTotalSummary/Partials/DeliveryExtraFee';

const styles = (theme) => ({
    OrderDetailFooter: {
        '& h1': {
            fontSize: '.875rem !important',
            fontWeight: '700 !important',
            textTransform: 'uppercase !important',
        },

        '& .section': {
            height: '20px',
            textAlign: 'right',
            '& > div, h1': {
                width: '130px',
                display: 'inline-block',
                [theme.breakpoints.down('sm')]: {
                    width: '200px',
                    maxWidth: '100%',
                    marginRight: '5px',
                },
                '&.shipping-label': {
                    width: '200px',
                },
            },
            '& > div:last-child': {
                [theme.breakpoints.down('sm')]: {
                    width: '90px',
                },
            },
            '&.delivery-extra-fee': {
                margin: '5px 0',
            },
            [theme.breakpoints.down('sm')]: {
                textAlign: 'left',
                paddingLeft: '20px',
            },
        },
        '& :nth-child(2)': {
            marginTop: '1rem',
        },
        '& .last': {
            marginTop: '24px',
        },
        '& .black': {
            fontWeight: '700',
            color: '#2e2c2c !important',
            '& span': {
                fontSize: '20px !important',
                color: '#8e8e8e !important',
            },
        },
        '& .sm-mt-3': {
            [theme.breakpoints.down('sm')]: {
                marginTop: '3rem',
            },
        },
        '& .md-hide': {
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
    },
});

class DesktopOrderFooter extends React.PureComponent {
    render() {
        const featureFlags = this.props.featureFlags;
        const orderDetails = this.props.orderDetails;

        let productTotal = 0;
        orderDetails.taxTotal = 0;
        orderDetails.deliveryFee = 0;
        orderDetails.productTotal = 0;
        orderDetails.shippingTotal = 0;
        orderDetails.discountTotal = 0;

        orderDetails.orders.forEach((order) => {
            order.items.forEach((orderItem) => {
                orderDetails.deliveryFee += +orderItem.deliveryFee;
            });

            orderDetails.shippingTotal = +((+orderDetails.shippingTotal || 0) + (+order.billingProfile.shippingCharge)).toFixed(2);
            orderDetails.taxTotal = +((+orderDetails.taxTotal || 0) + (+order.billingProfile.tax)).toFixed(2);
            orderDetails.discountTotal = ((+orderDetails.discountTotal || 0) + (Math.abs(+order.billingProfile.promotionDiscountAmount))).toFixed(2);

            if (order.billingProfile.orderSubTotal) {
                productTotal = +((+productTotal || 0) + (+order.billingProfile.orderSubTotal)).toFixed(2);
            } else {
                productTotal = +productTotal + +(((+order.items[0].price) * (+order.items[0].quantity)).toFixed(2));
            }
        });
        orderDetails.productTotal = productTotal.toFixed(2);

        if (orderDetails.deliveryFee && orderDetails.shippingTotal) {
            orderDetails.shippingTotal = (orderDetails.shippingTotal - orderDetails.deliveryFee).toFixed(2);
        }

        return (
            <Grid container className={this.props.classes.OrderDetailFooter} direction="column">
                <Grid className="section">
                    <Grid item xsOffset={3} xs={2}><h1>Billing Details:</h1></Grid>
                    <Grid item xsOffset={3} xs={2} />
                </Grid>
                {
                    orderDetails.productTotal
                        ? (
                            <Grid className="section subtotal">
                                <Grid item xsOffset={3} xs={2}>Subtotal:</Grid>
                                <Grid item xsOffset={3} xs={2}>${orderDetails.productTotal}</Grid>
                            </Grid>
                        ) : ''
                }
                <Grid className="section">
                    <Grid item xsOffset={3} xs={4} className="shipping-label">Shipping Charges / Surcharges:</Grid>
                    <Grid item xsOffset={3} xs={2}>${orderDetails.shippingTotal}</Grid>
                </Grid>

                {
                    orderDetails?.deliveryFee
                        ? (
                            <Grid className="section delivery-extra-fee">
                                <DeliveryExtraFee
                                    flags={featureFlags}
                                    stateDeliveryFee={{
                                        4: orderDetails.deliveryFee,
                                    }}
                                />
                            </Grid>
                        ) : ''
                }
                <Grid className="section">
                    <Grid item xsOffset={3} xs={2}>Tax:</Grid>
                    <Grid item xsOffset={3} xs={2}>${orderDetails.taxTotal}</Grid>
                </Grid>
                {
                    +orderDetails.discountTotal
                        ? (
                            <Grid className="section">
                                <Grid item xsOffset={3} xs={2}>Discount:</Grid>
                                <Grid item xsOffset={3} xs={2}>${orderDetails.discountTotal}</Grid>
                            </Grid>
                        ) : ''
                }

                <Grid className="section last">
                    <Grid item xsOffset={3} xs={2}>Order Total:</Grid>
                    <Grid item xsOffset={3} xs={2}>${orderDetails.orderTotal}</Grid>
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6} className="section sm-mt-3 md-hide">
                    <Link to="/track-order" className="black">
                        Track a different Order
                    </Link>
                </Grid>
            </Grid>
        );
    }
}

DesktopOrderFooter.propTypes = {
    classes: object.isRequired,
    orderDetails: object.isRequired,
    featureFlags: object.isRequired,
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});

export default connect(mapStateToProps)(withStyles(styles)(DesktopOrderFooter));
